import { render, staticRenderFns } from "./migrationNotesModal.vue?vue&type=template&id=7c280a25&scoped=true"
import script from "./migrationNotesModal.vue?vue&type=script&lang=js"
export * from "./migrationNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c280a25",
  null
  
)

export default component.exports